import { Breadcrumb, Button, Card, Popconfirm, Row, Steps, Tooltip } from 'antd'
import BankSelectDetails from '../../../../components/Finance/Lender/ContractForm/BankSelectDetails'
import useFetchSelect from '../../../../elements/Hooks/useFetchSelect'
import { isEmpty } from 'lodash'
import BankDetails from '../../../../components/Finance/Lender/ContractForm/BankDetails'
import Communication from '../../../../components/Finance/Lender/ContractForm/Communication'
import KeyTerms from '../../../../components/Finance/Lender/ContractForm/KeyTerms'
import Overview from '../../../../components/Finance/Lender/ContractForm/Overview'
import CustomSpin from '../../../../elements/CustomSpin'
import useTitle from '../../../../elements/Hooks/useTitle'
import React, { Fragment } from 'react'
import style from './style.css'

const Step = Steps.Step

function AddContract(props) {
  const titles = {
    new: 'Create new Finance Contract',
    update: 'Update Finance Contract',
  }
  const descriptions = {
    new: 'You can add new Finance Account by following the steps below.',
    update: 'You need to follow the steps below to update Account Contract.',
  }

  const {
    type,
    fetchingContract,
    member,
    lender,
    fetchingMember,
    submitting,
    contract,
    skip,
    next,
    prev,
    updating,
    submit,
    update,
    communicationCmpRef,
    overviewCmpRef,
    key,
    showSkip,
    currentStep,
    updateContract,
    BankDetailsCmp,
    keyTermsCmpRef,
  } = props

  useTitle(type === 'update' ? `Update ${contract.code}` : 'Create new Contract')

  const isInterCompany = contract.type === 'interCompany'

  const submitButton = {
    new: (
      <Popconfirm title="Sure to submit?" onConfirm={submit}>
        <Button loading={submitting} type="primary">
          Submit
        </Button>
      </Popconfirm>
    ),
    update: (
      <Popconfirm title="Sure to Update?" onConfirm={update}>
        <Button loading={updating} type="primary">
          Update
        </Button>
      </Popconfirm>
    ),
  }

  const { SelectData: ContractSelect, data: otherContracts } = useFetchSelect({
    url: `/lenders/contracts/${(lender.owner || '').replace('members/', '')}?type=bank`,
    dependencyArray: [lender],
    dontFetch: isEmpty(lender._key),
    mapFunction: contract._id ? (i) => i.filter((j) => j._id !== contract._id) : null,
  })

  console.log(otherContracts, isInterCompany, otherContracts.length !== 0)

  let steps = [
    {
      title: 'Account Overview',
      content: <Overview {...props} ref={overviewCmpRef} />,
      key: 'overview',
    },
    {
      title: 'Key Terms',
      content: <KeyTerms {...props} ref={keyTermsCmpRef} />,
      key: 'keyTerms',
    },
    {
      title: 'Communication',
      content: <Communication {...props} supplier={lender} ref={communicationCmpRef} type={type} contract={contract} />,
      key: 'communication',
    },
    {
      title: 'Bank Details',
      content: isInterCompany ? (
        <BankSelectDetails ref={BankDetailsCmp} {...{ ContractSelect, contract }} />
      ) : (
        <BankDetails
          updateContract={updateContract}
          lender={lender}
          member={member}
          type={type}
          ref={BankDetailsCmp}
          contract={contract}
        />
      ),
      key: 'bank-details',
    },
  ]

  if (type === 'update') steps = steps.filter((s) => s.key !== 'lines')

  return (
    <CustomSpin spinning={fetchingContract}>
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Finance</Breadcrumb.Item>
            <Breadcrumb.Item href="#/finance/lenders/list">Finance Partner List</Breadcrumb.Item>
            <Breadcrumb.Item href={`#/finance/lenders/${member._key}/#contracts`}>{member.fn}</Breadcrumb.Item>
            <Breadcrumb.Item>{type === 'update' ? contract.code : titles[type]}</Breadcrumb.Item>
          </Breadcrumb>
          <h2 className={style.title}>{titles[type]}</h2>
          <p className={style.paragraph}>{descriptions[type]}</p>
        </Row>
      </Card>
      <Card loading={fetchingMember} className={style.contentCard}>
        <Steps current={currentStep}>
          {steps.map((item) => (
            <Step key={item.key} title={item.title} />
          ))}
        </Steps>
        <div style={{ marginTop: '50px', marginBottom: '10px' }} className="steps-content">
          {steps[currentStep].content}
        </div>
        <div className="steps-action" style={{ textAlign: 'center', paddingTop: 20 }}>
          {currentStep > 0 && (
            <Button style={{ marginRight: 8 }} onClick={() => prev()}>
              Previous
            </Button>
          )}
          {currentStep < steps.length - 1 && (
            <Button style={{ width: '100px' }} type="primary" onClick={next}>
              Next
            </Button>
          )}
          {currentStep < steps.length - 1 && showSkip && (
            <Tooltip title="Skip validation for now">
              <Button icon="double-right" shape="dashed" style={{ marginLeft: 10 }} onClick={() => skip()} />
            </Tooltip>
          )}
          {currentStep === steps.length - 1 &&
            (submitButton[type] || (
              <Popconfirm title="Sure to submit?" onConfirm={submit}>
                <Button loading={submitting} type="primary">
                  Submit
                </Button>
              </Popconfirm>
            ))}
        </div>
      </Card>
    </CustomSpin>
  )
}

export default AddContract
